import { jsx } from "react/jsx-runtime";

//#region src/components/slider/SliderLabel.tsx
/**
* Renders a manually positioned min/max label for the slider.
*
* @param position - "min" or "max" to determine label alignment.
* @param value - The value to display.
*
* This is a temporary workaround due to limitations in the current version of Mantine.
* Once we upgrade to Mantine v8, we can remove this component and use the new `domain` prop
* provided by the Mantine Slider.
*/
const SliderLabel = ({ position, value }) => {
	const isMin = position === "min";
	return /* @__PURE__ */ jsx("div", {
		style: {
			position: "absolute",
			left: isMin ? "0%" : "100%",
			transform: isMin ? "translateX(0%)" : "translateX(-100%)",
			textAlign: isMin ? "left" : "right"
		},
		children: value
	});
};

//#endregion
export { SliderLabel };